import React from 'react';
import { voiceReminderContent } from '../rich-content/voice-reminder-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const VoiceReminderDetailPage = () => {
  return <AutomaticPageBuilder content={voiceReminderContent} />;
};

export default VoiceReminderDetailPage;
